import { render, staticRenderFns } from "./Constels.vue?vue&type=template&id=21e33f6e&scoped=true"
import script from "./Constels.vue?vue&type=script&lang=js"
export * from "./Constels.vue?vue&type=script&lang=js"
import style0 from "./Constels.vue?vue&type=style&index=0&id=21e33f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e33f6e",
  null
  
)

export default component.exports